"use strict";
exports.__esModule = true;
exports.SAML_IDPS = void 0;
exports.SAML_IDPS = {
    saml_okta: {
        name: 'Okta Workforce',
        logo: 'okta'
    },
    saml_google: {
        name: 'Google Workspace',
        logo: 'google'
    },
    saml_microsoft: {
        name: 'Microsoft Azure AD',
        logo: 'azure'
    },
    saml_custom: {
        name: 'SAML',
        logo: 'saml'
    }
};
